import React, {Suspense, useEffect, useState} from 'react' ;
import { Canvas } from "@react-three/fiber";
import { Html, useProgress, OrbitControls, useGLTF } from "@react-three/drei";
import { Scrollbars } from 'react-custom-scrollbars';
import load from '../../images/loaderMobile.gif';
import axios from 'axios';
import d3 from '../../images/market/testt.glb';
import monos  from '../../images/accumulation/monos.png';
import back  from '../../images/market/back.svg';
import dark  from '../../images/market/darkShape.svg';
import light  from '../../images/market/lightShape.svg';
import icon  from '../../images/market/360.gif';
import RegisterModal from '../landing/registerModal';
import { addressZero, checkIsWalletConnected, checkNetwork, getNetwork } from '../../web3Utils';
import { allowance, approveTokens, getUserAddress } from '../../web3Helper';
import { toast } from 'react-toastify';
import fire from '../../images/market/fire.gif';
import { getNetworkName } from '../../utils';
import { SaleModuleService } from '../../services/SaleModuleService';
import { AuctionModuleService } from '../../services/AuctionModuleService';
import { OfferModuleService } from '../../services/OfferModuleService';
import OfferModel from './OfferModal';
import { FormattedDate } from 'react-intl';
import { NftTokenService } from '../../services/NftTokenService';
import { getContractAddress } from "../../utils/abiHelper";
import AuctionModal from './AuctionModal';
import Countdown from 'react-countdown';
import { SALE_TYPE } from '../../constants';

const ThreeDView = ({match, history}) => {
  const today = new Date();

  const [toggle, setToggle] = useState(false);
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [isCorrectNetwork, setIsCorrectNetwork] = useState(false);
  const [userAddress, setUserAddress] = useState('');
  const [inventory, setInventory] = useState(null);
  const [purchaseAmount, setPurchaseAmount] = useState(0);
  const [approvalAmount, setApprovalAmount] = useState(0);
  const [isContractDataLoading, setIsContractDataLoading] = useState(true);
  const [isOffersLoading, setIsOffersLoading] = useState(true);
  const [isBidsLoading, setIsBidsLoading] = useState(true);

  const [isPurchaseInProgress, setIsPurchaseInProgress] = useState(false);
  const [isApprovalInProgress, setIsApprovalInProgress] = useState(false);
  const [isRemoveOfferInProgress, setIsRemoveOfferInProgress] = useState(-1);

  const [isAcceptOfferInitInProgress, setIsAcceptOfferInitInProgress] = useState(-1);
  const [isNftApprovalInProgress, setIsNftApprovalInProgress] = useState(-1);
  const [isAcceptingOfferInProgress, setIsAcceptingOfferInProgress] = useState(-1);

  const [ approvalRequiredFromNft, setApprovalRequiredFromNft] = useState(-1);
  const [ offerIndexToAccept, setOfferIndexToAccept] = useState(-1);
  const [ nftOwner, setNftOwner] = useState('');

  const [isOfferModelOpen, setIsOfferModelOpen] = useState(false);
  const [isAuctionModalOpen, setIsAuctionModelOpen] = useState(false);
  const [isAcceptBidInProgress, setIsAcceptBidInProgress] = useState(-1);
  const [isRemoveBidInProgress, setIsRemoveBidInProgress] = useState(-1);

  const [offers, setOffers] = useState([]);
  const [assetInfo, setAssetInfo] = useState({});
  const [bids, setBids] = useState([]);
  const [networkId, setNetworkId] = useState(0);



  const array = [0,1,2,3,4,5,6,7,8,9];
  const Model = ({d3}) => {
    const { scene } = useGLTF(d3);
    return <primitive object={scene} />;
  }

  const skills = () =>{ 
    
    return (
    <div className="skills-div">
      <h5>MONSTER SKILLS</h5>
      <div>
        <p>ATTACK</p> 
        <p>{array.map((a, index)=> (<img className={`${index === 0 ? 'first': ''}`} src={inventory 
          && inventory.attributes.attack / 10  < index + 1 ? light : dark} alt=""/>))} <span className="last-span">
            {inventory && inventory.attributes.attack}/100</span></p>
      </div>
      <div>
        <p>DEFENCE </p>
          <p>{array.map((a, index)=> (<img className={`${index === 0 ? 'first': ''}`} src={inventory && inventory.attributes.defence /10 < index +1 ? light : dark} alt="" />))} <span className="last-span">{inventory && inventory.attributes.defence}/100</span></p>
      </div>
      <div>
        <p>SPEED</p>
        <p> {array.map((a, index)=> (<img className={`${index === 0 ? 'first': ''}`} src={inventory && inventory.attributes.speed /10 < index +1 ? light : dark} alt="" />))} <span className="last-span">{inventory && inventory.attributes.speed}/100</span></p>
      </div>
      <div>
        <p>LIFE</p>
          <p> {array.map((a, index)=> (<img className={`${index === 0 ? 'first': ''}`} src={inventory && inventory.attributes.health /10  < index +1 ? light : dark} alt="" />))} <span className="last-span">{inventory && inventory.attributes.health}/100</span></p>
      </div>
    </div>
  )}
  function Loader() {
    const { progress } = useProgress()
    return <Html
      style={{
        position: 'relative',
      }}
      zIndexRange={[100, 0]}
      calculatePosition={(el, camera, size) => [0,0]}
    >
      <div> 
        <img width="100%" src={load} alt="" /> 
        <div className="load-div"> {parseFloat(progress).toFixed(2)}% Loaded!</div>
      </div>
    </Html>
  }
  const getInventory = async (id)=> {
    try {
    const response = await axios.get(`api/app/asset/raw/${match.params.id}`);
    setInventory(response.data.asset)

    }
    catch(e) {
      console.log(e);
    }    
  }

  const getOffers = () => {
    const offerModuleService = new OfferModuleService();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsOffersLoading(true)
    offerModuleService.getOffers({
      tokenId
    }).then((nftOffers) => {
      setOffers([
        ...offers, 
        ...nftOffers
      ])
    }
      
    ).finally(() => setIsOffersLoading(false))
  }
  const getDataFromNetwork = async () => {
    const networkId = await getNetwork();
    setNetworkId(networkId)

    const tokenId = inventory && inventory['tokenId'][networkId];

    const saleModuleService = new SaleModuleService();
    const auctionModuleService = new AuctionModuleService();
    
    const nftTokenService = new NftTokenService();
    setIsContractDataLoading(true);

    Promise.allSettled([
      saleModuleService.getMarketItem( tokenId ),
      auctionModuleService.getMarketItem( tokenId ),
      nftTokenService.ownerOf( tokenId ),
    ]).then(([
      saleMarketItemData,
      auctionMarketItemData,
      tokenOwner
    ]) => {
      tokenOwner.value && setNftOwner(tokenOwner.value);
      setIsContractDataLoading(false);

      if(auctionMarketItemData.value && auctionMarketItemData.value.owner !== addressZero()) {
        setAssetInfo({ ...auctionMarketItemData.value });
        console.log('auctionMarketItemData', tokenId, auctionMarketItemData);

        setIsBidsLoading(true);
        auctionModuleService.getBids({
          tokenId
        }).then((nftBids) => {
          console.log('nftBids', nftBids);
          setBids([
            ...bids, 
            ...nftBids
          ])
        }
      
        )
        .finally(() => setIsBidsLoading(false))

      } else if( saleMarketItemData.value && saleMarketItemData.value.owner !== addressZero()) {
        setAssetInfo({ ...saleMarketItemData.value });
        getOffers()
      } else {
        getOffers()
      }
    })
  }
  useEffect(()=> {
    getInventory();
    checkIsWalletConnected().then((isConnected) => setIsWalletConnected(isConnected))
    checkNetwork()
      .then((isNetworkId) => setIsCorrectNetwork(isNetworkId))
    getUserAddress().then((userAddress) => setUserAddress(userAddress))
  },[])

  useEffect(()=> {
    getDataFromNetwork()
  }, [inventory])
  const checkAllowance = async () => {

    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');
    const saleModuleService = new SaleModuleService();

    const value = assetInfo.price;
    if(!value) return toast.error('Purchase Unavailable!');
   
    const allowanceAmount = await allowance({ spenderContractType: saleModuleService.contractType });

    if(allowanceAmount < value) {
      setApprovalAmount(value - allowanceAmount);
    }
    setPurchaseAmount(value)
  }

  const handleApproval = async () => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');
    const saleModuleService = new SaleModuleService();

    setIsApprovalInProgress(true);
    try {
      await approveTokens({ value: 1000000, spenderContractType: saleModuleService.contractType });
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
    } catch(err) {
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
      setPurchaseAmount(0)
    } 
  }

  const handleBuyTokens = async () => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const saleModuleService = new SaleModuleService();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsPurchaseInProgress(true);
    saleModuleService.purchase({
      tokenId,
      value: purchaseAmount,
    }).then(() => {
      setPurchaseAmount(0);
      setIsPurchaseInProgress(false);
      getDataFromNetwork();
      toast.success("NFT Purchased Successfully!");
    }).catch((err) => {
      setPurchaseAmount(0);
      setIsPurchaseInProgress(false);
      toast.error(err);
    })
  }

  const handleRemoveOffer = async (index) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const offerModuleService = new OfferModuleService();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsRemoveOfferInProgress(index);
    offerModuleService.removeOffer({
      tokenId,
      index
    }).then(() => {
      setIsRemoveOfferInProgress(-1);
      toast.success("Offer Removed Successfully!");
    }).catch((err) => {
      setIsRemoveOfferInProgress(-1);
      toast.error(err);
    })
  }

  const handleAcceptOfferInit = async (index) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    setApprovalRequiredFromNft(-1);
    setOfferIndexToAccept(-1);

    const nftTokenService = new NftTokenService();
    const offerModuleService = new OfferModuleService();
    const contractAddress = await getContractAddress(offerModuleService.contractType);

    setIsAcceptOfferInitInProgress(index);
    nftTokenService.isApprovedForAll(
      userAddress,
      contractAddress,
    ).then((isApprovedForAll) => {
      setIsAcceptOfferInitInProgress(-1);
      setApprovalRequiredFromNft(!isApprovedForAll ? index : -1);
      setOfferIndexToAccept(index)
    }).catch((err) => {
      setIsAcceptOfferInitInProgress(-1);
      setOfferIndexToAccept(-1);
      toast.error(err);
    })
  }

  const handleApprovalFromNft = async (index) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const nftTokenService = new NftTokenService();
    const offerModuleService = new OfferModuleService();
    const contractAddress = await getContractAddress(offerModuleService.contractType);

    setIsNftApprovalInProgress(index);
    nftTokenService.setApprovalForAll(
      contractAddress,
      true
    ).then(() => {
      setIsNftApprovalInProgress(-1);
      setApprovalRequiredFromNft(-1);
    }).catch((err) => {
      setIsNftApprovalInProgress(-1);
      setApprovalRequiredFromNft(-1);
      setOfferIndexToAccept(-1);
      toast.error(err);
    })
  }

  const handleConfirmingAcceptOffer = async (index) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const offerModuleService = new OfferModuleService();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsAcceptingOfferInProgress(index);
    offerModuleService.acceptOffer({
      tokenId,
      index: offerIndexToAccept
    }).then(() => {
      setIsAcceptingOfferInProgress(-1);
      setOfferIndexToAccept(-1);
      toast.success("Offer Accepted Successfully!");
    }).catch((err) => {
      setIsAcceptingOfferInProgress(-1);
      setOfferIndexToAccept(-1);
      toast.error(err);
    })
  }

  const handleRemoveBid = async (index) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const auctionModuleService = new AuctionModuleService();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsRemoveBidInProgress(index);
    auctionModuleService.removeBid({
      tokenId,
      index
    }).then(() => {
      setIsRemoveBidInProgress(-1);
      toast.success("Bid Removed Successfully!");
    }).catch((err) => {
      setIsRemoveBidInProgress(-1);
      toast.error(err);
    })
  }

  const handleAcceptBid = async (index) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const auctionModuleService = new AuctionModuleService();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsAcceptBidInProgress(index);
    auctionModuleService.acceptBid({
      tokenId,
      index
    }).then(() => {
      setIsAcceptBidInProgress(-1);
      toast.success("Auction Bid Accepted!");
    }).catch((err) => {
      setIsAcceptBidInProgress(-1);
      toast.error(err);
    })
  }

  return (
    <div className="row row-3d no-gutters">
      <RegisterModal toggle={toggle} onCloseModal={()=> setToggle(false)} />
      <OfferModel toggle={isOfferModelOpen} inventory={inventory} onCloseModal={()=> setIsOfferModelOpen(false)} />
      <AuctionModal toggle={isAuctionModalOpen} inventory={inventory} onCloseModal={()=> setIsAuctionModelOpen(false)} />
      <div className=" mob col-lg-5 col-sm-12 col-lg-pull-7">
        <div className="d-div">
          <img className="icon" src={icon} alt=""/>
          {inventory && inventory.category !== 'PLOT' && <Canvas camera={{position: [-2, 1, -10]}}>
            <OrbitControls />
          <ambientLight intensity={1} />
          <spotLight position={[30, 50, -30]} angle={1} />
          <Suspense fallback={<Loader />}>
            <Model d3={ inventory && inventory.modelUrl3d ? inventory.modelUrl3d : d3} />
            {/* <Model d3={ d3} /> */}
          </Suspense>
        </Canvas>}
        <div className={`${inventory && inventory.category !== 'PLOT' ? 'hide': ''}`}>
        {inventory && inventory.category === 'PLOT' &&  <img width="100%" src={inventory && inventory.modelUrl3d} alt=""/>
        } </div>
        </div>
      </div>
      <div className="col-lg-7 col-sm-12 col-lg-push-5">
        <div className="detail-box">
          <div className="heading-div">
            <h3>
              <img src={back} alt="" onClick={()=> history.push(`/market-place/assets/${match.params.name}`)} /> {inventory && inventory.name.toUpperCase()}
            </h3>
            <h5>
              <img src={monos} alt=""/> 
              { !isWalletConnected || !isCorrectNetwork ? <span>N.A</span>
                : isContractDataLoading ? <img style={{width:'55px'}} src={load} alt=""/> 
                : assetInfo.price ? assetInfo.price
                : 0
              }
            </h5>
          </div>
          <Scrollbars style={ { height: 430, width: '100%' } }
            className="scroll-right"
            renderTrackHorizontal={ props => <div { ...props } className="track-horizontal"/> }
            renderTrackVertical={ props => <div { ...props } className="track-vertical"/> }
            >
            <div className="description-div">
              <p>{inventory && inventory.description}</p>
            </div>
            {match.params.name === 'monster' && skills()}
            <div className="auction-div">
              <h5>DETAIL</h5>
              
              <div className="detail">
                {
                  !isWalletConnected ? 
                    <div>
                     <h5>Connect your Wallet.</h5>
                    </div>
                  : !isCorrectNetwork ? 
                    <div>
                      <h5>Switch to {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.</h5>
                    </div>
                  : isContractDataLoading ? 
                    <div>
                      <img src={fire} alt=""/> Loading...
                    </div>
                  : 
                    <>
                      <div>
                        <span>Token ID</span>
                        <h5>{inventory && inventory.tokenId && inventory.tokenId[networkId]}</h5>
                      </div>
                      <div>
                        <span>Sale Type</span>
                        <h5>
                          {
                            assetInfo.saleType === SALE_TYPE['NORMAL'] ? 
                              'NORMAL' 
                            : assetInfo.saleType === SALE_TYPE['AUCTION'] ?
                               'AUCTION'
                            : 'NONE'
                          }
                        </h5>
                      </div>
                      {
                        !!assetInfo.startTime &&
                         <div>
                          <span>Starts At</span>
                          <h5>
                            <FormattedDate
                              timeZone="UTC"
                              hour12
                              dateStyle="long"
                              value={assetInfo.startTime * 1000} 
                            /> 
                          </h5>
                        </div>
                      }
                      {
                        !!assetInfo.endTime &&
                        <div>
                          <span>Ends At</span>
                          <h5>
                            <FormattedDate
                              timeZone="UTC"
                              hour12
                              dateStyle="long"
                              value={assetInfo.endTime * 1000} 
                            /> 
                          </h5>
                        </div>
                      }
                      {
                        assetInfo.saleType === SALE_TYPE['NORMAL'] ? 
                        <>
                          <div>
                            <span>Price</span>
                            <h5><img src={monos} alt="" />{ assetInfo.price }</h5>
                          </div>
                          <div>
                            <span>Seller</span>
                            <h5>{assetInfo.owner.substr(0,6) + '...'  + assetInfo.owner.substr(-4)}</h5>
                          </div>
                        </>
                         : assetInfo.saleType === SALE_TYPE['AUCTION'] ? 
                          <>
                            <div>
                              <span>Bid Increment</span>
                              <h5><img src={monos} alt="" />{ assetInfo.bidIncrement }</h5>
                            </div>
                            <div>
                              <span>Min Bid</span>
                              <h5><img src={monos} alt="" />{ assetInfo.highestBindingBid }</h5>
                            </div>
                            <div>
                              <span>Highest Bidder</span>
                              <h5>{assetInfo.highestBidder.substr(0,6) + '...'  + assetInfo.highestBidder.substr(-4)}</h5>
                            </div>
                            <div>
                              <span>Highest Bid</span>
                              <h5><img src={monos} alt="" /> {assetInfo.highestBid}</h5>
                            </div>
                            <div>
                              <span>Seller</span>
                              <h5>{assetInfo.owner.substr(0,6) + '...'  + assetInfo.owner.substr(-4)}</h5>
                            </div>
                          </> 
                       :  
                        <>
                          <div>
                            <span>Owner</span>
                            <h5>{nftOwner.substr(0,6) + '...'  + nftOwner.substr(-4)}</h5>
                          </div>
                        </> 
                      }
                      {
                        inventory && inventory.attributes && inventory.attributes.type && 
                        <div>
                          <span>Type</span>
                          <h5>{inventory && inventory.attributes.type.replace(/_/g, " ")}</h5>
                        </div>
                      }
                    </>
                }
              </div>
            </div>
          </Scrollbars>
          {
            !isWalletConnected ?
              <button  className="btn buy" disabled={true}>
                Connect your Wallet.
              </button>
            : !isCorrectNetwork ? 
              <button  className="btn buy" disabled={true}>
                Switch to {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.
              </button>
            : isContractDataLoading ?
              <button className="btn buy" disabled={true}>
                Loading...
              </button>
            : 
              <>
                {
                  assetInfo.startTime && new Date(assetInfo.startTime * 1000) > today ? 
                    <button 
                      disabled={true}
                      className="btn buy" 
                    >
                      <Countdown date={new Date( assetInfo.startTime * 1000 )} />
                    </button>
                  : <>
                    {
                      assetInfo.saleType === SALE_TYPE['NORMAL'] && 
                      <>
                        {
                          approvalAmount ? 
                          <button onClick={()=> handleApproval()} className="btn buy" disabled={isApprovalInProgress} >
                            { isApprovalInProgress ? 'Please Wait!' : `Approve` }
                          </button>
                          : purchaseAmount ?
                            <button onClick={()=> handleBuyTokens()} className="btn buy" disabled={isPurchaseInProgress}>
                              { isPurchaseInProgress ? 'Please Wait!' : `Confirm Transfer of ${purchaseAmount} Tokens`}
                            </button>
                          : new Date(assetInfo.startTime * 1000) < today && today < new Date(assetInfo.endTime * 1000) ?
                            <button onClick={()=> checkAllowance()} className="btn buy">
                              Buy
                            </button>
                          : <button disabled className="btn buy">
                              Sale Ended!
                            </button>
                        }
                      </>
                      }

                      {
                        assetInfo.saleType === SALE_TYPE['AUCTION'] && 
                          <> 
                            {
                              new Date(assetInfo.startTime * 1000) < today && today < new Date(assetInfo.endTime * 1000) ?
                                <button 
                                  className="btn buy" 
                                  onClick={() => setIsAuctionModelOpen(true)}
                                >
                                  Place Bid
                                </button>
                              : <button disabled className="btn buy">
                                  Auction Ended!
                                </button>
                            }
                          </>
                      }
                  </>
                }
                
            <button 
                  className="btn buy ml-5" 
                  onClick={() => setIsOfferModelOpen(true)}
                >
                  Make Offer
                </button>
              </>
          }
        </div>
      </div>
      <div className="col-lg-5 col-sm-12 web">

      <div className="d-div">
        <img className="icon" src={icon} alt=""/>
       {inventory && inventory.category !== 'PLOT' && <Canvas camera={{position: [-2, 1, -10]}}>
        <OrbitControls />
          <ambientLight intensity={1} />
          <spotLight position={[30, 50, -30]} angle={1} />
          <Suspense fallback={<Loader />}>
            <Model d3={ inventory && inventory.modelUrl3d ? inventory.modelUrl3d : d3} />
            {/* <Model d3={ d3} /> */}
          </Suspense>
        </Canvas>}
        <div className={`${inventory && inventory.category !== 'PLOT' ? 'hide': ''}`}>
        {inventory && inventory.category === 'PLOT' &&  <img width="100%" src={inventory && inventory.modelUrl3d} alt=""/>
        } </div>
      </div>
    </div>
    <div className='col-12'>
      {
        assetInfo.saleType === SALE_TYPE['AUCTION'] ?
          <div  className={"m-3 p-4 d-flex flex-direction-column offer-class"}>
            <h2 className="">Current Bids</h2>
            <div className="table-responsive last">
              <table className="table">
                <thead>
                  <tr>
                    <th>Offerer</th>
                    <th>Value</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    isContractDataLoading || isBidsLoading ? 
                      <tr className="change-tr">
                        <td colSpan={4}>
                          Loading Bids!
                        </td>
                      </tr>
                    : bids.length ? 
                      bids.map((bid, index) => 
                        <tr className="change-tr">
                          <td>
                            {bid.offerer}
                          </td>
                          <td>
                            {bid.value}
                          </td>
                          <td>
                            <FormattedDate
                              timeZone="UTC"
                              hour12
                              dateStyle="long"
                              value={bid.timestamp * 1000} 
                            /> 
                          </td>
                          <td>
                            {
                              userAddress === nftOwner && 
                                <button onClick={()=> handleAcceptBid(index)} className="btn buy" disabled={isAcceptBidInProgress === index}>
                                  { isAcceptBidInProgress === index ? 'Please Wait!' : 'Accept Offer' }
                                </button>
                            }                      
                            {
                              userAddress === bid.offerer &&
                                <button 
                                  disabled={isRemoveBidInProgress === index}
                                  className="btn buy ml-5" 
                                  onClick={() => handleRemoveBid(index)}
                                >
                                  { isRemoveBidInProgress === index ? 'Please Wait!' : 'Remove offer' }
                                </button>
                            }
                          </td>
                        </tr>
                      )
                    :
                    <tr className="change-tr">
                      <td colSpan={4}>
                        No Bids!
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        :
        <div  className={"m-3 p-4 d-flex flex-direction-column offer-class"}>
          <h2 className="">Current Offers</h2>
          <div className="table-responsive last">
            <table className="table">
              <thead>
                <tr>
                  <th>Offerer</th>
                  <th>Value</th>
                  <th>Valid Till</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  isContractDataLoading || isOffersLoading ? 
                    <tr className="change-tr">
                      <td colSpan={4}>
                        Loading Offers!
                      </td>
                    </tr>
                  : offers.length ? 
                    offers.map((offer, index) => 
                      <tr className="change-tr">
                        <td>
                          {offer.offerer}
                        </td>
                        <td>
                          {offer.value}
                        </td>
                        <td>
                          <FormattedDate
                            timeZone="UTC"
                            hour12
                            dateStyle="long"
                            value={(offer.timestamp + offer.expireOffset) * 1000} 
                          /> 
                        </td>
                        <td>

                          {
                            userAddress === nftOwner && 
                            <>
                              {
                                approvalRequiredFromNft === index ? 
                                  <button onClick={()=> handleApprovalFromNft(index)} className="btn buy" disabled={isNftApprovalInProgress === index} >
                                    { isNftApprovalInProgress === index ? 'Please Wait!' : `Approve` }
                                  </button>
                                : offerIndexToAccept === index ?
                                  <button onClick={()=> handleConfirmingAcceptOffer(index)} className="btn buy" disabled={isAcceptingOfferInProgress === index}>
                                    { isAcceptingOfferInProgress === index ? 'Please Wait!' : `Confirm Transfer of NFT`}
                                  </button>
                                :
                                  <button onClick={()=> handleAcceptOfferInit(index)} className="btn buy" disabled={isAcceptOfferInitInProgress === index}>
                                    { isAcceptOfferInitInProgress === index ? 'Please Wait!' : 'Accept Offer' }
                                  </button>
                              }
                            </>
                          }                      
                          {
                            userAddress === offer.offerer &&
                            <button 
                              disabled={isRemoveOfferInProgress === index}
                              className="btn buy ml-5" 
                              onClick={() => handleRemoveOffer(index)}
                            >
                              { isRemoveOfferInProgress === index ? 'Please Wait!' : 'Remove offer' }
                            </button>
                          }
                        </td>
                      </tr>
                    )
                  :
                  <tr className="change-tr">
                    <td colSpan={4}>
                      No Offers!
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
 
  )
}

export default ThreeDView;